module.exports = __webpack_public_path__ + "career-icon-life.1RdkAy1G.svg";